/**
 * Utilitaires de domaine pour le routing app.revertai.io vs revertai.io
 *
 * - revertai.io        → Landing, Login, Signup, Invite
 * - app.revertai.io    → Onboarding + App (protégé)
 * - localhost          → tout (dev, comportement identique)
 */

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

// Treat localhost AND Vercel preview URLs as single-origin (no cross-domain split)
export const IS_DEV =
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname.endsWith('.vercel.app');

export const IS_APP_DOMAIN = IS_DEV || hostname === 'app.revertai.io';

export const APP_ORIGIN = IS_DEV
  ? window.location.origin
  : 'https://app.revertai.io';

export const MAIN_ORIGIN = IS_DEV
  ? window.location.origin
  : 'https://revertai.io';

/** Redirige vers app.revertai.io (cross-domain en prod, no-op en dev) */
export function goToApp(path = '/home') {
  window.location.href = `${APP_ORIGIN}${path}`;
}

/** Redirige vers revertai.io (cross-domain en prod, no-op en dev) */
export function goToMain(path = '/login') {
  window.location.href = `${MAIN_ORIGIN}${path}`;
}
